import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Grid, Stack, TextField, Typography } from '@mui/material';
import StepLayout from '../../components/StepLayout/StepLayout';
import { useTunnelDispatch, useTunnelState } from '../../context/TunnelContext';
import { MODELS_BY_BRAND } from '../../utils/mockData';

export default function ModelSelection() {
  const navigate = useNavigate();
  const dispatch = useTunnelDispatch();
  const { currentShoe } = useTunnelState();
  const [otherModel, setOtherModel] = useState('');

  useEffect(() => {
    if (!currentShoe.brand) {
      navigate('/nouvelle-demande/marque', { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const models = MODELS_BY_BRAND[currentShoe.brand] ?? [];

  function selectModel(model) {
    dispatch({ type: 'SET_MODEL', model });
    navigate('/nouvelle-demande/pointure');
  }

  function submitOtherModel() {
    if (!otherModel.trim()) {
      return;
    }
    selectModel(otherModel.trim());
  }

  function skip() {
    navigate('/nouvelle-demande/pointure');
  }

  return (
    <StepLayout title={`Modèle ${currentShoe.brand}`}>
      {models.length > 0 && (
        <Grid container spacing={2} sx={{ mb: 4 }}>
          {models.map((model) => (
            <Grid item xs={6} sm={4} md={3} key={model}>
              <Button
                fullWidth
                variant="outlined"
                size="large"
                onClick={() => selectModel(model)}
              >
                {model}
              </Button>
            </Grid>
          ))}
        </Grid>
      )}

      {models.length === 0 && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Aucun modèle prérempli pour cette marque.
        </Typography>
      )}

      <Stack direction="row" spacing={2} sx={{ maxWidth: 480, mb: 3 }}>
        <TextField
          fullWidth
          label="Autre modèle"
          value={otherModel}
          onChange={(e) => setOtherModel(e.target.value)}
        />
        <Button variant="contained" onClick={submitOtherModel}>
          Valider
        </Button>
      </Stack>

      <Stack sx={{ maxWidth: 480 }}>
        <Button variant="text" onClick={skip}>
          Passer cette étape
        </Button>
      </Stack>
    </StepLayout>
  );
}
